import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useStableCallback } from '@main/shared/browser';
import { useEffect } from 'react';

type LabelFocusPluginProps = {
  id: string;
};

export function LabelFocusPlugin({ id }: LabelFocusPluginProps) {
  const [editor] = useLexicalComposerContext();
  const handleClick = useStableCallback(() => {
    if (editor.isEditable()) {
      editor.focus();
    }
  });

  useEffect(() => {
    const label = document.querySelector(`label[for="${id}"]`);
    if (label) {
      label.addEventListener('click', handleClick);
    }
    return () => {
      if (label) {
        label.removeEventListener('click', handleClick);
      }
    };
  }, [id, handleClick]);

  return null;
}
